import {Pipe, PipeTransform} from '@angular/core';
import {PositionStatus} from "@services";

@Pipe({
    name: 'positionStatus',
    standalone: true
})
export class PositionStatusPipe implements PipeTransform {
    transform(value: PositionStatus | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case PositionStatus.Deactivated: return "Deactivated (ADP)";

            default: return value;
        }
    }
}
